import React, { useEffect, useState, useRef } from "react";
import { TextField, PrimaryButton, Dropdown } from "@fluentui/react";
import { Grid } from "@mui/material";
import axios from "axios";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CommonDataTable from "../CommonDataTable";
import { getQuoteCompareVersionList, GetQuoteBackupRecords, QuoteTransferBackupDataAsync } from "../../Services/CommonFunctions";
import { TransferDialogComponent } from '../../Services/dialogComponent';
import { SimpleSnackbarWithOutTimeOut } from '../../Components/SnackBar';

function QuoteBackup() {
    const container = useRef();
    const [searchText, setSearchText] = useState("");
    const [jobInstance, setJobInstance] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [msgVisible, setMsgVisible] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [dynamicData, setDynamicData] = useState([]);
    const [setId, setSetId] = useState(0);
    const [JobId, setJobId] = useState(0);
    const column = [
        {
            name: "Id",
            selector: (row) => row.SetId,
            sortable: true,
        },
        {
            name: "Job Id",
            selector: (row) => row?.JobCode,
        },
        {
            name: "CreatedOn",
            selector: (row) => row?.CreatedOn,
            cell: (row) => formatTo12HourIST(row?.CreatedOn),
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <PrimaryButton
                    className="ref_button"
                    text={
                        <span
                            style={{ color: "white", fontSize: "10px", fontWeight: "bold" }}
                        >
                            View
                        </span>
                    }
                    styles={{
                        rootHovered: {
                            backgroundColor: "#251ca8",
                        },
                    }}
                    onClick={() => {
                        setSetId(row?.SetId);
                        setJobId(row?.JobId);
                        handleDialogOpen(row);
                    }}
                />
            ),
        },
    ];


    const formatTo12HourIST = (date) => {
        // Adjust the date to IST (UTC+5:30)
        date = new Date(date);
        // const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
        const istDate = new Date(date.getTime());

        // Get the date components
        const year = istDate.getFullYear();
        const month = (istDate.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based, so add 1
        const day = istDate.getDate().toString().padStart(2, "0");

        // Get the hours, minutes, and seconds
        let hours = istDate.getHours();
        const minutes = istDate.getMinutes();
        const seconds = istDate.getSeconds();

        // Determine AM/PM suffix
        const period = hours >= 12 ? "PM" : "AM";

        // Convert hours from 24-hour to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // The hour '0' should be '12'

        // Format the date & time
        const formattedDate = `${year}-${month}-${day}`;
        const formattedTime = `${hours}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")} ${period}`;

        return `${formattedDate} ${formattedTime}`;
    };

    const getData = async () => {
        document.body.classList.add("loading-indicator");
        try {
            let data = await getQuoteCompareVersionList(searchText);
            console.log("data", data);
            if (data.length) {
                data = data.map(rec => ({ ...rec, JobCode: searchText }));
                setJobInstance(data);
            } else {
                setJobInstance([]);
            }
        }
        catch (error) {
            console.error("Error fetching quote backup versions:", error);
        } finally {
            document.body.classList.remove("loading-indicator");
        }
    }

    const handleDialogOpen = async (row) => {
        setOpen(true);
        try {
            document.body.classList.add("loading-indicator");
            const response = await GetQuoteBackupRecords(searchText, row?.SetId);
            if (response?.length) {
                formTableDataFormatting(response)
            }
        }
        catch (error) {
            console.error("Error fetching backup records:", error);
        }
        finally { }
    };

    const formTableDataFormatting = (response) => {
        const question = [...new Map(response.map(rec => [rec.GroupId, rec.ChecklistQuestion])).values()];
        const documentNames = [...new Map(response.map(rec => [rec.DocumentName, rec.DocumentName])).values()];
        const data = [];
        const columns = [
            {
                name: "ChecklistQuestion",
                selector: (row) => row['checklistQuestion'],
                sortable: true
            }
        ];
        documentNames.forEach((doc) => {
            columns.push({
                name: doc,
                selector: (row) => row[doc],
                sortable: true
            });
        });
        question.forEach((ques) => {
            let obj = {
                checklistQuestion: ques
            };
            documentNames.forEach(element => {
                obj = {
                    ...obj,
                    [element]: response.find(rec => rec.DocumentName === element && rec.ChecklistQuestion === ques)?.ExtractedValue || ""
                }
            });
            data.push(obj);
        });
        setDynamicColumns(columns);
        setDynamicData(data);
    }

    const handleSearch = () => {
        getData();
    };

    const handleDialogClose = () => {
        setOpen(false);
        setSetId(0);
        setDynamicColumns([]);
        setDynamicData([]);
    }

    const handleTransferDialogClose = async (proceedTransfer) => {
        if (proceedTransfer) {
            try {
                document.body.classList.add("loading-indicator");
                const res = await QuoteTransferBackupDataAsync(searchText, setId, JobId);
                if (res.status === 200) {
                    setTimeout(() => {
                        container.current.showSnackbar(
                            "Data Transfered Successfully.",
                            "info",
                            true
                        );
                        setTimeout(() => {
                            // container.current.hideSnackbar();
                        }, 2000);
                    });
                }
            } catch (error) {
                console.error("Error transferring backup data:", error);
            } finally {
                document.body.classList.remove("loading-indicator");
            }
        }
        setOpenDialog(false);
        setMsgText('');
        setSetId(0);
        setDynamicColumns([]);
        setDynamicData([]);
        setOpen(false);
    }

    const remainderDailog = async (JobId) => {
        if (JobId) {
            setOpenDialog(true);
            setMsgText('Are You Sure You Want to Transfer the Data');
            setTimeout(() => {
                setMsgVisible(false);
                setMsgText('');
            }, 4500);
        }
    }

    return (
        <div style={{ width: "100%", padding: "0px", marginLeft: "5px" }}>
            <div>
                <div style={{ display: "flex", marginTop: "5px" }}>
                    <TextField
                        placeholder="Search JobId..."
                        value={searchText}
                        onChange={(e, newValue) => {
                            setSearchText(newValue);
                        }}
                        style={{
                            width: "250px",
                            marginRight: "8px",
                        }}
                    />
                    <PrimaryButton
                        text={
                            <span style={{ color: "white", fontWeight: "bold" }}>Search</span>
                        }
                        disabled={!(searchText)}
                        onClick={handleSearch}
                        style={{
                            marginLeft: "10px",
                            height: "32.1px",
                            fontSize: "10px",
                        }}
                    />
                </div>
            </div>
            <br />
            <div>
                <CommonDataTable column={column} data={jobInstance} />
            </div>
            <div>
                <Dialog
                    open={open}
                    onClose={handleDialogClose}
                    fullScreen={true}
                    scroll={"paper"}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span> <b>TransferData JobID -</b> {searchText},  <b> Set Id -</b> {setId}  </span>
                            <span style={{ fontSize: "smaller", color: "indianred" }}>
                                Click 'esc' key to close
                            </span>
                        </div>
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <div style={{ gap: '10px', display: 'flex', alignItems: 'center', paddingBottom: '10px' }}>
                            <span>DispatchedJobIdTransferData</span>
                            <PrimaryButton
                                text={
                                    <span style={{ color: "white", fontWeight: "bold" }}>Transfer</span>
                                }
                                onClick={() => {
                                    remainderDailog(JobId);
                                }}
                                style={{
                                    height: "32.1px",
                                    fontSize: "10px",
                                }}
                                disabled={!dynamicData || dynamicData.length === 0}
                            />
                        </div>
                        <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                            <CommonDataTable column={dynamicColumns} data={dynamicData} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose}>Close</Button>
                    </DialogActions>
                    {openDialog && <TransferDialogComponent isOpen={openDialog} onClose={(e) => handleTransferDialogClose(e)} message={msgText} />}
                    <SimpleSnackbarWithOutTimeOut ref={container} />

                </Dialog>
            </div>
        </div>
    )
}

export default QuoteBackup